import { createRouter, createWebHistory } from 'vue-router';
import LandingView from './views/LandingView.vue';
import CreateView from './views/CreateView.vue';
import HistoryView from './views/HistoryView.vue';
import { useAuthStore } from './stores/auth';

let authInitialised = false;

const routes = [
  {
    path: '/',
    name: 'Landing',
    component: LandingView,
  },
  {
    path: '/create',
    name: 'Create',
    component: CreateView,
    meta: { requiresAuth: true },
  },
  {
    path: '/history',
    name: 'History',
    component: HistoryView,
    meta: { requiresAuth: true },
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: () => import('./views/PrivacyPolicyView.vue'),
  },
  {
    path: '/data-deletion',
    name: 'DataDeletion',
    component: () => import('./views/DataDeletionView.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to) => {
  const authStore = useAuthStore();

  if (!authInitialised) {
    await authStore.init();
    authInitialised = true;
  }

  if (to.meta.requiresAuth && !authStore.isLoggedIn) {
    return { name: 'Landing' };
  }
});

export default router;
